import * as React from 'react';
import SelectField from '../../common/form-controls/SelectField';
import FieldHandler from '../../../models/interfaces/FieldHandler';

export const CATEGORIES = [
    { value: '1', text: 'Mitigated (alternative control in place)' },
    { value: '2', text: 'Waiver (risk accepted)' },
];

interface ExemptionCategoryInputProps extends FieldHandler<string> {}

export class ExemptionCategoryInput extends React.Component<ExemptionCategoryInputProps> {
    render() {
        return (
            <SelectField
                key="duration-select"
                label="Exemption Category"
                className="full-width"
                options={CATEGORIES.map(o => ({
                    value: String(o.value),
                    text: o.text
                }))}
                value={this.props.value ?? ''}
                {...this.props}
            />
        );
    }
}